module.exports = __webpack_public_path__ + "img/report.473a3c99.svg";